/* TLC product page v2. On for every product page in this theme; the page head (snippets/doc-head-core)
   decides and sets html.tlc2-on early so the CSS applies from the first paint. ?tlc2=0 turns it off in that
   browser tab to compare with the old page, ?tlc2=1 turns it back on.
   1. No size picked by default. A stand-in "Select your size" button shows until one is chosen
      (not on fully sold out products, which keep their normal Sold out button).
   2. Sizes show sold out / "N left".
   3. Colour row becomes zoomed fabric squares (two rows, then "+N"). Final sale note.
   4. Sticky bar: no pre-picked size, compact.
   5. "Loved by" line is not mum-only.
   6. Price without "AUD".
   7. Fit note without the dash.
   8. "Pair it with" cards: names only and (1,234) review counts, like the collection pages.
   Data comes from window.TLCPDP2 (printed by the footer loader section). */
(function () {
  if (window.__tlcPdp2) return; window.__tlcPdp2 = true;
  if (!document.documentElement.classList.contains('tlc2-on')) return;
  var D = window.TLCPDP2 || { sizes: [], final: false };
  var picked = /[?&]variant=/.test(location.search);
  var MSG = 'Select your size';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function sizeFieldset() {
    return $$('fieldset.option-selector').filter(function (f) {
      return /size/i.test(f.getAttribute('data-option') || '');
    })[0];
  }

  /* ---------- 1. size first ----------
     Until a size is chosen the real Add to cart buttons are hidden and a stand-in
     "Select your size" button (which cannot add anything) shows in their place. */
  function markPicked() {
    if (picked) return;
    picked = true;
    document.documentElement.classList.remove('tlc2-nosize');
    var hint = $('.tlc2-hint'); if (hint) hint.remove();
  }
  function askForSize() {
    var fs = sizeFieldset();
    if (!fs) return;
    var y = fs.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top: y, behavior: 'smooth' });
    fs.classList.remove('tlc2-shake'); void fs.offsetWidth; fs.classList.add('tlc2-shake');
    if (!$('.tlc2-hint', fs)) {
      var h = document.createElement('p');
      h.className = 'tlc2-hint'; h.setAttribute('role', 'alert');
      h.textContent = 'Choose your size to add to cart';
      fs.appendChild(h);
    }
  }
  function addProxies() {
    $$('form[action*="/cart/add"] button[name="add"]').forEach(function (b) {
      if (b.classList.contains('tlc2-real')) return;
      b.classList.add('tlc2-real');
      var p = document.createElement('button');
      p.type = 'button';
      p.className = b.className.replace('tlc2-real', '').replace('add-to-cart', '') + ' tlc2-proxy';
      p.textContent = MSG;
      p.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); askForSize(); });
      b.parentNode.insertBefore(p, b);
    });
  }

  var sizesSetUp = false;
  function initSizes() {
    var fs = sizeFieldset();
    if (!fs) { picked = true; document.documentElement.classList.remove('tlc2-nosize'); return; }
    fs.classList.add('tlc2-sizes');
    var sizes = D.sizes || [];
    if (sizes.length && !sizes.some(function (v) { return v.a; })) {
      // fully sold out: keep the theme's own Sold out button
      picked = true; document.documentElement.classList.remove('tlc2-nosize');
      decorateSizes(fs);
      return;
    }
    if (!picked) document.documentElement.classList.add('tlc2-nosize');
    addProxies();
    decorateSizes(fs);
    if (sizesSetUp) return;
    sizesSetUp = true;
    fs.addEventListener('click', function (e) { if (e.isTrusted && e.target.closest('label, input')) markPicked(); });
    fs.addEventListener('change', function (e) { if (e.isTrusted) markPicked(); });
    document.addEventListener('click', function (e) {
      if (e.isTrusted && e.target.closest && e.target.closest('.tlc-sticky-size-btn')) markPicked();
    }, true);
  }

  /* ---------- 2. stock per size ---------- */
  function decorateSizes(fs) {
    var agg = {};
    (D.sizes || []).forEach(function (v) {
      var a = agg[v.s] || (agg[v.s] = { a: false, q: 0, t: false });
      if (v.a) a.a = true;
      if (v.t) { a.t = true; if (v.q > 0) a.q += v.q; }
    });
    $$('input[type="radio"]', fs).forEach(function (inp) {
      var lab = fs.querySelector('label[for="' + inp.id + '"]');
      var d = agg[inp.value];
      if (!lab || !d) return;
      if (!d.a) lab.classList.add('tlc2-sold');
      else if (d.t && d.q > 0 && d.q <= 5 && !$('.tlc2-left', lab)) {
        var s = document.createElement('span'); s.className = 'tlc2-left'; s.textContent = d.q + ' left';
        lab.appendChild(s); lab.classList.add('tlc2-low');
      }
    });
  }

  /* ---------- 3. colours ---------- */
  function initColours() {
    var row = $('.product-form .related-swatches');
    if (!row) return;
    row.classList.add('tlc2-colours');
    $$('.tlc-swatch-hidden', row).forEach(function (x) { x.classList.remove('tlc-swatch-hidden'); });
    var tog = $('.tlc-swatch-toggle'); if (tog) tog.style.display = 'none';
    $$('.related-swatch', row).forEach(function (a) {
      a.style.display = '';
      a.hidden = false;
      if (/^final sale/i.test(a.getAttribute('title') || '')) a.classList.add('tlc2-final');
      var img = $('img', a); if (img && img.getAttribute('sizes') !== '120px') img.setAttribute('sizes', '120px');
    });
    // long colour lists: two rows, then a "+N" square that shows the rest
    var all = $$('.related-swatch', row);
    if (all.length > 14 && !row.classList.contains('tlc2-all') && !$('.tlc2-more', row)) {
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'tlc2-more';
      more.textContent = '+' + (all.length - 13);
      more.setAttribute('aria-label', 'Show all ' + all.length + ' colours');
      more.addEventListener('click', function () { row.classList.add('tlc2-all'); more.remove(); });
      row.appendChild(more);
    }
    if (D.final) {
      var buy = $('buy-buttons.buy-buttons-row') || $('.buy-buttons-row');
      if (buy && !$('.tlc2-final-note')) {
        var n = document.createElement('div');
        n.className = 'tlc2-final-note'; n.setAttribute('role', 'note');
        n.innerHTML = 'Final sale<span>No returns on final sale items.</span>';
        buy.parentNode.insertBefore(n, buy);
      }
    }
  }

  /* ---------- 4. sticky bar ---------- */
  function initSticky() {
    var s = $('sticky-atc');
    if (!s) return;
    s.classList.add('tlc2-sticky');
    if (!picked) {
      $$('.tlc-sticky-size-btn', s).forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
    }
    var agg = {};
    (D.sizes || []).forEach(function (v) { var a = agg[v.s] || (agg[v.s] = { a: false }); if (v.a) a.a = true; });
    $$('.tlc-sticky-size-btn', s).forEach(function (b) {
      var d = agg[b.getAttribute('data-size-value')];
      if (d && !d.a) b.classList.add('tlc2-sold');
    });
  }

  /* ---------- 5 to 7. copy ---------- */
  function initCopy() {
    var eb = $('.tlcpt-eb');
    if (eb && /mamas|mums|moms/i.test(eb.textContent)) {
      eb.textContent = eb.textContent.replace(/mamas|mums|moms/i, 'of the club');
    }
    var fit = $('.tlc-fg__callout-text');
    if (fit) fit.textContent = fit.textContent.replace(/\s*[—–]\s*(\w)/, function (m, c) { return '. ' + c.toUpperCase(); });
    stripAud();
    if (copyObserved) return; copyObserved = true;
    $$('.price, .sticky-atc__details').forEach(function (p) {
      new MutationObserver(stripAud).observe(p, { childList: true, characterData: true, subtree: true });
    });
  }
  var copyObserved = false;
  var stripping = false;
  function stripAud() {
    if (stripping) return; stripping = true;
    $$('.price .js-value, .sticky-atc .js-value, .price__current, .price__was').forEach(function (el) {
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /\s?AUD\b/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\s?AUD\b/g, '');
      });
    });
    stripping = false;
  }

  /* ---------- 8. "Pair it with" cards: same look as the collection pages ---------- */
  function tidyRelated() {
    var SKIP = /^(final sale|sale|pre-?order|coming soon)$/i;
    $$('[id*="related-products"] product-block .product-block__title:not([data-tlc2])').forEach(function (t) {
      t.setAttribute('data-tlc2', '1');
      var full = t.textContent.trim();
      var parts = full.split('|').map(function (p) { return p.trim(); }).filter(function (p) { return p && !SKIP.test(p); });
      if (parts.length) { t.setAttribute('title', full); t.textContent = parts[0]; }
    });
    $$('[id*="related-products"] product-block .cc-rating-custom-caption:not([data-tlc2])').forEach(function (c) {
      c.setAttribute('data-tlc2', '1');
      var m = c.textContent.match(/(\d[\d,]*)/);
      if (m) c.textContent = '(' + Number(m[1].replace(/,/g, '')).toLocaleString('en-AU') + ')';
    });
  }

  function init() {
    document.body.classList.add('tlc2');
    try { initSizes(); } catch (e) {}
    try { initColours(); } catch (e) {}
    try { initSticky(); } catch (e) {}
    try { initCopy(); } catch (e) {}
    try { tidyRelated(); } catch (e) {}
  }
  // run as early as possible, then again once the theme and the other TLC scripts have finished;
  // every step only changes what is not already done
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function () { init(); setTimeout(init, 600); setTimeout(init, 1800); });
})();
